/* eslint-disable react/prop-types, react/destructuring-assignment */
import React, { useContext, useEffect } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AWSRumContext } from '../../../app/context/AWSRumContext'
import SessionTimeoutModal from '../../../app/pages/home/modals/SessionTimeoutModal'
import NotificationsPanel from '../../../app/partials/layout/NotificationsPanel'
import OnboardingChecklist from '../../../app/partials/layout/OnboardingChecklist'
import Uploads from '../../../app/partials/layout/Uploads'
import UserProfile from '../../../app/partials/layout/UserProfile'
import { /* signOut, */ verifySession } from '../../../app/util/auth.util'
import * as sessionModal from '../../ducks/sessionModal'

function Topbar(props) {
  const { currentUser, history } = props
  const dispatch = useDispatch()
  const intl = useIntl()
  const awsRum = useContext(AWSRumContext)

  // check if tokens are valid on mount and on every 5min
  useEffect(() => {
    verifySession({ dispatch, intl, awsRum })
    const interval = setInterval(() => verifySession({ dispatch, intl, awsRum }), 5 * 60 * 1000)
    return () => {
      clearInterval(interval)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [awsRum, dispatch, intl])

  useIdleTimer({
    element: document,
    debounce: 250,
    events: ['keydown', 'mousedown', 'MSPointerDown'],
    timeout: 1000 * 60 * 60,
    promptBeforeIdle: 1000 * 60,
    onIdle: () => history.push('/logout'),
    onPrompt: (event, idleTimer) => {
      dispatch(
        sessionModal.actions.openSessionModal({
          description: intl.formatMessage({
            id: 'AUTH.SESSIONTIMEOUT.INACTIVE',
          }),
          refresh: true,
          idleTimer,
        }),
      )
    },
  })

  return (
    <div className="header__topbar">
      <Uploads />

      <OnboardingChecklist />

      <NotificationsPanel />

      <UserProfile showAvatar showHi showBadge currentUser={currentUser} />

      <SessionTimeoutModal history={history} />
    </div>
  )
}

export default withRouter(Topbar)
